'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _FormattedHTMLMessage = require('I18n/components/FormattedHTMLMessage');

var _FormattedHTMLMessage2 = _interopRequireDefault(_FormattedHTMLMessage);

var _UIFormControl = require('UIComponents/legacy/UIFormControl');

var _UIFormControl2 = _interopRequireDefault(_UIFormControl);

var _EmailAddress = require('PatternValidationJS/patterns/EmailAddress');

var _EmailAddress2 = _interopRequireDefault(_EmailAddress);

var _colors = require('HubStyleTokens/colors');

var _EmailCaptureInput = require('./EmailCaptureInput');

var _EmailCaptureInput2 = _interopRequireDefault(_EmailCaptureInput);

var _EmailCaptureSuccess = require('./EmailCaptureSuccess');

var _EmailCaptureSuccess2 = _interopRequireDefault(_EmailCaptureSuccess);

var _ConsentToCommunicate = require('./ConsentToCommunicate');

var _ConsentToCommunicate2 = _interopRequireDefault(_ConsentToCommunicate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ENTER_KEY = 13;

var EmailCaptureForm = _react2.default.createClass({
  displayName: 'EmailCaptureForm',

  propTypes: {
    buttonColor: _react.PropTypes.string.isRequired,
    channel: _react.PropTypes.string,
    companyName: _react.PropTypes.string,
    consentToCommunicateMessage: _react.PropTypes.string,
    hasVisitorEmail: _react.PropTypes.bool.isRequired,
    locale: _react.PropTypes.string,
    onSubmit: _react.PropTypes.func.isRequired,
    requiresConsentToCommunicate: _react.PropTypes.bool,
    showCaptureMessage: _react.PropTypes.bool.isRequired,
    systemOnline: _react.PropTypes.bool.isRequired,
    text: _react.PropTypes.string
  },

  getInitialState: function getInitialState() {
    return {
      error: false,
      email: '',
      consentToCommunicate: false,
      submitting: false
    };
  },
  getValidationMessage: function getValidationMessage() {
    if (!this.state.error) return null;

    return _react2.default.createElement(
      'div',
      { className: 'text-center' },
      _react2.default.createElement(_FormattedHTMLMessage2.default, { message: 'conversationsUI.emailCapture.errorMessage' })
    );
  },
  onEmailSubmitSuccess: function onEmailSubmitSuccess() {
    this.setState({
      submitting: false
    });
  },
  onEmailSubmitFailure: function onEmailSubmitFailure() {
    this.setState({
      error: true,
      submitting: false
    });
  },
  handleKeyPress: function handleKeyPress(e) {
    if (e.which === ENTER_KEY) {
      this.handleSubmit();
    }
  },
  handleChange: function handleChange(e) {
    this.setState({
      email: e.target.value,
      error: false
    });
  },
  handleConsentToggle: function handleConsentToggle() {
    this.setState({
      consentToCommunicate: !this.state.consentToCommunicate
    });
  },
  handleSubmit: function handleSubmit() {
    var _this = this;

    var channel = this.props.channel;
    var _state = this.state,
        email = _state.email,
        consentToCommunicate = _state.consentToCommunicate;


    if (_EmailAddress2.default.test(email)) {
      this.setState({
        error: false,
        submitting: true
      }, function () {
        _this.props.onSubmit({
          channel: channel,
          email: email,
          consentToCommunicate: consentToCommunicate
        }).then(function (_ref) {
          var error = _ref.error;

          if (error) {
            _this.onEmailSubmitFailure(error);
          } else {
            _this.onEmailSubmitSuccess();
          }
        }).done();
      });
    } else {
      this.setState({ error: true });
    }
  },
  shouldRenderCaptureText: function shouldRenderCaptureText() {
    return Boolean(this.props.text) && this.props.showCaptureMessage;
  },
  renderCaptureMessage: function renderCaptureMessage() {
    if (!this.shouldRenderCaptureText()) {
      return null;
    }

    return _react2.default.createElement(
      'span',
      {
        style: {
          color: _colors.SLINKY,
          fontWeight: 500,
          fontSize: '10px'
        }
      },
      this.props.text
    );
  },
  render: function render() {
    // TODO: pass consent copy from the welcome message
    var consentToCommunicate = this.state.consentToCommunicate;


    if (this.props.hasVisitorEmail) {
      return _react2.default.createElement(_EmailCaptureSuccess2.default, { systemOnline: this.props.systemOnline });
    }

    return _react2.default.createElement(
      _UIFormControl2.default,
      {
        error: this.state.error,
        validationMessage: this.getValidationMessage()
      },
      _react2.default.createElement(
        'div',
        {
          className: (0, _classNames2.default)('email-capture', 'm-top-1', {
            'inline-capture-message': this.shouldRenderCaptureText()
          })
        },
        this.renderCaptureMessage(),
        _react2.default.createElement(_EmailCaptureInput2.default, {
          error: this.state.error,
          submitting: this.state.submitting,
          value: this.state.email,
          locale: this.props.locale,
          onChange: this.handleChange,
          onKeyPress: this.handleKeyPress,
          buttonColor: this.props.buttonColor,
          onSubmit: this.handleSubmit
        }),
        this.props.requiresConsentToCommunicate && _react2.default.createElement(_ConsentToCommunicate2.default, {
          companyName: this.props.companyName,
          message: this.props.consentToCommunicateMessage,
          consentToCommunicate: consentToCommunicate,
          onChange: this.handleConsentToggle
        })
      )
    );
  }
});

exports.default = EmailCaptureForm;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-conversations/static-1.5219/js/components/emailCapture/EmailCaptureForm.js
// module id = 1095
// module chunks = 2 3